import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { MOCKUP_IMAGE } from '../../data/content';
export function Hero({
  ctaAnchorId
}: {
  ctaAnchorId: string;
}) {
  return <header className="w-full bg-cream-100" data-id="element-182" data-mp="cvl3r30odasi">
      <div className="mx-auto w-full max-w-3xl px-5 pb-12 pt-8 sm:px-8 sm:pb-16 sm:pt-12" data-id="element-183" data-mp="cxxn9km2zt7o">
        <div className="flex items-center justify-center gap-2" data-id="element-184" data-mp="hw8tlld63ll5">
          <span className="flex h-7 w-7 items-center justify-center rounded-full bg-navy-800 text-[11px] font-bold text-renal-400" data-id="element-185" data-mp="mszdkjs3f1bu">
            K
          </span>
          <p className="font-display text-lg font-bold tracking-tight text-navy-800" data-id="element-186" data-mp="vmm3vudj7cdn">
            Dra. <span className="text-renal-600" data-id="element-187" data-mp="10lfhrnwqd5ec">Karito</span>
          </p>
        </div>

        <p className="mx-auto mt-6 w-fit rounded-full border border-renal-600/25 bg-renal-50 px-3 py-1.5 text-center text-[10.5px] font-bold uppercase tracking-[0.12em] text-renal-700 sm:text-xs" data-id="element-188" data-mp="10njn8aaa2cgq">
          Ruta Enfermedad Renal™
        </p>

        <h1 className="mt-4 text-center font-display text-[31px] font-extrabold leading-[1.1] tracking-tight text-navy-900 sm:text-5xl sm:leading-[1.07]" data-id="element-189" data-mp="9o2r3owkawon">
          Toma decisiones seguras ante cualquier paciente renal en menos de{' '}
          <em className="not-italic text-renal-600 italic font-bold" data-id="element-190" data-mp="3vvas6f0g8hev">5 minutos</em>
        </h1>

        <p className="mx-auto mt-5 max-w-xl text-center text-[15px] leading-relaxed text-navy-700/85 sm:text-lg" data-id="element-191" data-mp="3rv0dmdylcioe">
          Desde la interpretación de una creatinina elevada hasta la decisión de tratar, monitorizar
          o derivar. Sin revisar múltiples guías ni dudar en plena consulta.
        </p>

        <p className="mx-auto mt-4 max-w-xl text-center text-[13.5px] font-semibold leading-relaxed text-navy-800 sm:text-base" data-id="element-192" data-mp="imo7peih41ms">
          Más de 1.000 médicos hispanohablantes ya usan Ruta Enfermedad Renal™ para convertir la
          incertidumbre clínica en decisiones claras y respaldadas por evidencia.
        </p>

        <div className="mt-8" data-id="element-193" data-mp="16c8phu2w4suh">
          <img src={MOCKUP_IMAGE} alt="Los 6 tomos y 5 bonos de Ruta Enfermedad Renal™ en versión digital" className="mx-auto w-full max-w-lg" width={1080} height={1080} data-id="element-194" data-mp="30ldz738o04nf" />
        </div>

        <div className="mt-6" data-id="element-195" data-mp="2qu1f4xt3yiry">
          <CtaButton id={ctaAnchorId} size="lg" label="Quiero la Ruta Renal lista" sub="Descarga inmediata • Pago único • Acceso de por vida • Garantía de 7 días" data-id="element-196" data-mp="2vuxfx2i5xot5" />
        </div>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11.5px] font-semibold text-navy-700/75 sm:text-xs" data-id="element-197" data-mp="2mvafaix9cn15">
          {['Basado en KDIGO', 'PDF de alta calidad', 'Listo para usar hoy'].map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-198" data-mp="2cy60j45qrtud">
              <CheckIcon className="h-3.5 w-3.5 text-renal-600" aria-hidden="true" data-id="element-199" data-mp="66epj2lqgm2x" />
              {item}
            </li>)}
        </ul>
      </div>
    </header>;
}